export default function Media() {
  return <>Media</>;
}
